import { Routes, Route, Navigate } from "react-router-dom";
import Logistics from "./Logistics";
import AgriLogistics from './AgriLogistics';
import ColdChain from './ColdChain';
import Distribution from './Distribution';
import FleetTransportation from './FleetTransportation';
import OverlandExpress from './OverlandExpress';
import InternationalFreight from './InternationalFreight';
import CustomBrokrage from './CustomBrokrage';
// import Warehouse from './Warehouse';
import RegionalTrucking from './RegionalTrucking';
// import PackNGO from './Packngo';
import ExpoLogistics from './ExpoLogistics';
// import ProjectLogistics from './ProjectLogistics';

const logisticsRoutes = [
    {routeName: 'overland-express' , component: <OverlandExpress/>},
    {routeName: 'fleettransport' , component: <FleetTransportation/>},
    // {routeName: 'warehousing' , component: <Warehouse/>},
    {routeName: 'distribution' , component: <Distribution/>},
    {routeName: 'internationalfreight' , component: <InternationalFreight/>},
    {routeName: 'customsbrokerage' , component: <CustomBrokrage/>},
    // {routeName: 'pack-n-go' , component: <PackNGO/>},
    {routeName: 'expologistics' , component: <ExpoLogistics/>},
    {routeName: 'coldchain' , component: <ColdChain/>},
    // {routeName: 'project-logistics' , component: <ProjectLogistics/>},
    {routeName: 'agrilogistics' , component: <AgriLogistics/>},
    {routeName: 'regional-trade-TIR' , component: <RegionalTrucking/>},
    
];

const LogisticsRoutes = () => {
    return (
    <Routes>
       {logisticsRoutes.map((route, key)=> ( <Route key={key}  path={route.routeName} element={route.component}></Route> ))}
       <Route path="*" element={<Navigate to="/" /> }/>
    </Routes>)
}

export default LogisticsRoutes;